
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from './../_models/user';

import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ResultData } from '../_models/ResultData';
import { HeaderService } from './header.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  public registeredUser = new User()
  public userRegResponse = { rs: { status: 0 } }


  public userMessage: BehaviorSubject<string> = new BehaviorSubject<string>("");
  //public userMessageObservable = this.userMessage.asObservable

  public registrationData: BehaviorSubject<User> = new BehaviorSubject<User>(new User());
  //public responseObservable = this.registrationData.asObservable



  constructor(
    private http: HttpClient,
    private headerService:HeaderService
  ){}
  getAll():Observable<ResultData> {
    return this.http.get<ResultData>(`${environment.apiUrl}/users`, {headers:this.headerService.bearerJsonHeaders()}) ;
  }

  getById(id: number):Observable<ResultData> {
    return this.http.get<ResultData>(`${environment.apiUrl}/user/show/${id}`,{headers:this.headerService.bearerJsonHeaders()} )
  }
  sendPasswordLink(emailData: string):Observable<ResultData> {
    return this.http.post<ResultData>(`${environment.apiUrl}/user/request_password_reset_link`, emailData, {headers:this.headerService.openFormHeaders()})

  }
  generatePasswordLink(txData: string):Observable<ResultData> {
    return this.http.post<ResultData>(`${environment.apiUrl}/user/request_new_password_from_link`, {headers:this.headerService.openFormHeaders()})

  }
  register(user: User):Observable<ResultData> {
    return this.http.post<ResultData>(`${environment.apiUrl}/user/apiregister`, user.regData(), {headers: this.headerService.openFormHeaders()})
  }

  newGuardian(user: User):Observable<ResultData> {
    return this.http.post<ResultData>(`${environment.apiUrl}/user/apinewguardian`, user.regData(), {headers: this.headerService.openFormHeaders()})

  }
  verify(user: User):Observable<ResultData> {
    return this.http.post<ResultData>(`${environment.apiUrl}/user/apiverify`, user, {headers: this.headerService.openJsonHeaders()})

  }
  activateUserAccount(tx: string, ux: string):Observable<ResultData> {
    return this.http.post<ResultData>(`${environment.apiUrl}/user/apiactivate`, this.formatActivateData(tx, ux), {headers: this.headerService.openFormHeaders()})

  }
  update(user: User):Observable<ResultData> {
    return this.http.post<ResultData>(`${environment.apiUrl}/user/apiupdate`, user.formData(), {headers: this.headerService.openFormHeaders()})

  }


  formatActivateData(tx: string, ux: string) {
    let body = new URLSearchParams();
    body.set('tx', tx);
    body.set('ux', ux);
    return body.toString()
  }

  lockUnlockUser(userId: number):Observable<ResultData> {
    return this.http.get<ResultData>(`${environment.apiUrl}/user/lockUnlock/${userId}`, {headers:this.headerService.bearerJsonHeaders()})

  }

  getGuardianByStudentUserI(userId: number):Observable<ResultData> {
    return this.http.get<ResultData>(`${environment.apiUrl}/guardian/getGuardianByStudentUserI/${userId}`, {headers:this.headerService.bearerJsonHeaders()})
  }

  enableDisableUser(userId: number):Observable<ResultData> {
    return this.http.get<ResultData>(`${environment.apiUrl}/user/enableDisable/${userId}`, {headers:this.headerService.bearerJsonHeaders()})
  }
}
